"use strict";

var myAccomadationsListWidget = function () {
  var myAccomadationsListWidgetParams = {
    model: {},
    url: {},
    template: {}
  };

  function unbindHandlers() {
    $(document).off('click', '.prgress-achivement');
  }

  function bindHandlers() {
    $(document).on('click', '.prgress-achivement.-active', function () {
      LKCommon.openGalleryModal({
        modal: {
          selector: '#certificateModal',
          title: 'Сертификаты'
        },
        gallery: {
          hasTitle: true
        }
      });
    });
  }

  function setParams(myAccomadationsListParams) {
    myAccomadationsListWidgetParams = $.extend({}, myAccomadationsListWidgetParams, myAccomadationsListParams);
  }

  function init(myAccomadationsListParams) {
    unbindHandlers();
    setParams(myAccomadationsListParams);
    bindHandlers();
  }

  return {
    init: init
  };
}();